import { ArrowRight, MapPin, Phone, Star } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, SERVICE_AREA } from "../../lib/business";

const HERO_IMG =
  "https://images.pexels.com/photos/14231676/pexels-photo-14231676.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden flex items-end"
    >
      {/* Background image */}
      <img
        src={HERO_IMG}
        alt="Premium mobile car detailing on a luxury black vehicle"
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
      />
      {/* Overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/45 to-[#09090B]" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/30 to-transparent" />

      {/* Top-right floating chip */}
      <div className="absolute top-24 sm:top-28 right-4 sm:right-8 hidden sm:flex items-center gap-2 bg-white/5 backdrop-blur-xl border border-white/10 rounded-full px-4 py-2">
        <Star className="w-4 h-4 fill-[#E10600] text-[#E10600]" />
        <span className="font-body text-xs uppercase tracking-widest text-white/90">
          5.0 on Google
        </span>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24 sm:pb-32 pt-32 w-full">
        <div className="max-w-3xl">
          <div className="fade-up delay-1 inline-flex items-center gap-2 bg-white/5 backdrop-blur-xl border border-white/10 rounded-full px-4 py-2 mb-6">
            <MapPin className="w-4 h-4 text-[#E10600]" />
            <span className="font-body text-xs uppercase tracking-widest text-white/80">
              Mobile Service · {SERVICE_AREA}
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-display text-6xl sm:text-7xl lg:text-[8rem] font-black uppercase tracking-tighter leading-[0.85] text-white fade-up delay-2"
          >
            Rapid <span className="text-[#E10600]">Shine</span>
            <br />
            <span className="text-white/90">We come to you.</span>
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-6 max-w-xl font-body text-base sm:text-lg text-zinc-300 leading-relaxed fade-up delay-3"
          >
            Premium mobile carwash & detailing across Newcastle, NSW.
            Showroom-grade results at your driveway — no online booking,
            we keep it personal. Pick up the phone and let&apos;s talk.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-4 fade-up delay-4">
            <a
              href={PHONE_TEL}
              data-testid="call-now-hero"
              className="group inline-flex items-center justify-center gap-3 bg-[#E10600] hover:bg-[#FF2D1A] text-white font-display uppercase tracking-wide font-bold text-lg px-7 py-5 rounded-full transition-colors duration-200 shadow-[0_10px_40px_-10px_rgba(225,6,0,0.6)]"
            >
              <Phone className="w-5 h-5" />
              Call/Text Now: {PHONE_DISPLAY}
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href="#services"
              data-testid="hero-view-services"
              className="inline-flex items-center justify-center gap-2 border border-white/15 hover:border-white/40 bg-white/5 hover:bg-white/10 backdrop-blur text-white font-display uppercase tracking-wide font-bold text-base px-6 py-5 rounded-full transition-colors duration-200"
            >
              View Services
            </a>
          </div>

          {/* Trust row */}
          <div className="mt-12 grid grid-cols-3 gap-6 max-w-xl fade-up delay-4">
            {[
              { k: "Open", v: "7 Days · 7AM–5PM" },
              { k: "Mobile", v: "We Travel To You" },
              { k: "Detail", v: "Hand-Finished" },
            ].map((t) => (
              <div key={t.k}>
                <div className="font-display text-xs uppercase tracking-widest text-[#E10600]">
                  {t.k}
                </div>
                <div className="font-display text-base sm:text-lg uppercase font-bold text-white/90 mt-1 leading-tight">
                  {t.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
